//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[1,"Attachment",0,"SelectNXObject",0],[1,"Base",0,"SelectNXObject",0],[0,"BaseAnchorPoint",1,"Point",0],[0,"BaseAxisVector",1,"Direction",0],[0,"MotionType",1,0],[0,"Name",1,0],[0,"Positioning",1,0]],[[["attachment"],"SetAttachment",{},1,0],[["base"],"SetBase",{},1,0]],[]];
SPLM.Mechatronics.PhysicsJointBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.PhysicsJointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.PhysicsJointBuilder.MotionTypes = Object.freeze({
    "Dynamics" : "Dynamics", "Kinematics" : "Kinematics", "Articulation" : "Articulation"});

export default SPLM;